export const scrollbarStyles = (theme) => ({
    '&::-webkit-scrollbar-thumb': {
        background: theme.colors.bgScrollbarThumb,
    },
    '&::-webkit-scrollbar-thumb:hover': {
        background: theme.colors.bgScrollbarThumbHover,
    },
    '&::-webkit-scrollbar-track': {
        background: theme.colors.bgScrollbarTrack,
    },
    '&::-webkit-scrollbar-track:hover': {
        background: theme.colors.bgScrollbarTrackHover,
    },
    '&::-webkit-scrollbar': {
        width: 8,
    },
    'scrollbar-color': `${theme.colors.bgScrollbarThumb} ${theme.colors.bgScrollbarTrack}`,
    'scrollbar-width': 'thin',
});
//# sourceMappingURL=scrollbarStyles.js.map